// Route placeholder — content rendered by global AppShell client-side.
export default function InvoicesRoute() {
  return null;
}
